import {type AppState} from '../../types/app-state'

import {type Role} from '../../../values/Role'

export const rolesSelector = (state: AppState): Role[] => state.roles.roles

export const isFetchingRolesSelector = (state: AppState): boolean => state.roles.isFetching
